import { sound } from '@pixi/sound';
import { Container, Sprite, Texture } from 'pixi.js';
import { EventEmitter, Store, TextureFactory } from '../../core';
import { IEventEmitter, Point, Updatable, Vector } from '../../interface';
import seedrandom from 'seedrandom';

class MultiplayScaffolding extends EventEmitter implements Updatable, IEventEmitter {
  public width: number;
  public brokenable: boolean;
  public range: [number, number];
  public static: boolean;
  public container: Container;
  public velocity: Vector;
  public position: Point;
  private vanished: boolean;
  public isLast: boolean;
  private readonly stage: Container;

  constructor(options: {
    position: Point;
    brokenable: boolean;
    range: [number, number];
    static: boolean;
    isBottom: boolean;
    isLast: boolean;
    seed?: string;
  }) {
    super();
    const random = seedrandom(options.seed || `${Math.random()}`);

    this.container = new Container();
    this.stage = new Container();
    this.position = { x: options.position.x, y: options.position.y };
    this.velocity = { x: options.static ? 0 : Math.random() * 2, y: 0 };

    this.vanished = false;
    this.brokenable = options.brokenable;
    this.static = options.static;
    this.range = options.range;
    this.isLast = options.isLast;

    const rand = random();
    const anchor: Point = { x: 0, y: 0.5 };
    let texture: Texture;
    if (options.isBottom) {
      this.width = this.range[1];
      anchor.x = 0.01;
      anchor.y = 0.12;
      texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_1.png');
    } else if (options.brokenable) {
      // if (rand <= 0.5) {
      //   this.width = 435;
      //   texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_2.png');
      // } else {
      this.width = 226;
      texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_6.png');
      // }
    } else if (options.static) {
      // if (this.position.y >= -16000) {
      //   if (rand <= 0.5) {
      //     this.width = 500;
      //     anchor.x = 0.03;
      //     anchor.y = 0.4;
      //     texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_5.png');
      //   } else {
      //     this.width = 500;
      //     anchor.x = 0.05;
      //     anchor.y = 0.4;
      //     texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_4.png');
      //   }
      // } else {
      if (rand <= 0.4) {
        this.width = 500;
        anchor.x = 0.03;
        anchor.y = 0.4;
        texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_5.png');
      } else {
        this.width = 500;
        anchor.x = 0.05;
        anchor.y = 0.4;
        texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_4.png');
      }
      // }
    } else {
      // if (this.position.y >= -16000) {
      //   this.width = 442;
      //   anchor.y = 0.1;
      //   texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_7.png');
      // } else {
      // if (rand <= 0.2) {
      //   this.width = 216;
      //   anchor.y = 0.1;
      //   texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_8.png');
      // } else {
      this.width = 442;
      anchor.y = 0.1;
      texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_7.png');
      // }
      // }
    }

    const sprite = new Sprite(texture);
    sprite.anchor.set(anchor.x, anchor.y);

    if (options.isLast) {
      this.position.x = 0;
      this.width = 1080;
      sprite.texture = TextureFactory.instance.getSingleTexture('/textures/objects/etc/scaffolding_9.png');
      sprite.anchor.set(0.009, 0.85);
    }
    this.container.addChild(sprite);
    this.container.addChild(this.stage);
  }

  public update(elapsed: number): void {
    this.applyPosition();

    if (this.vanished && this.container.alpha >= 0.05 * elapsed) {
      this.container.alpha -= 0.05 * elapsed;
    } else if (this.vanished) {
      this.container.alpha = 0;
    }

    if (this.static) return;

    if (this.range[0] >= this.position.x + this.velocity.x * elapsed) {
      this.position.x = this.range[0];
      this.velocity.x = Math.abs(this.velocity.x);
    } else if (this.range[1] - this.width <= this.position.x + this.velocity.x * elapsed) {
      this.position.x = this.range[1] - this.width;
      this.velocity.x = -Math.abs(this.velocity.x);
    } else {
      this.position.x += this.velocity.x * elapsed;
    }
  }

  public vanish(): void {
    this.vanished = true;

    if (this.brokenable) {
      sound.play('/audio/pung.mp3', { loop: false, volume: Store.instance.state.volume as number });
    }
  }

  private applyPosition(): void {
    this.container.x = this.position.x;
    this.container.y = this.position.y;
    this.stage.x = 0;
    this.stage.y = 0;
  }

  public transition(prevState: string, nextState: string): void {
    //
  }
}

export default MultiplayScaffolding;
